













































































import WidgetMixins from '../../../../mixins/WidgetMixins';
import Component, { mixins } from 'vue-class-component';
import { carriers, loadWidget } from '@/utils/helpers';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { Getter, namespace } from 'vuex-class';
import { IDialogAndButtonAction, IPaymentDetails, IProduct, IResolveAccount, IUser, PayloadState } from '@/types/types';
const paymentDetailsModule = namespace('paymentDetails');
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { numeric, required } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'Field is required',
});
extend('numeric', {
  ...numeric,
  message: 'Invalid mobile money number provided',
});

@Component({
  name: 'AddPaymentMethod',
  components: {
    ValidationProvider,
    ValidationObserver,
    SkeletonPreloader: loadWidget('widgets/SkeletonPreloader'),
  },
})
export default class GetLink extends mixins(WidgetMixins) {
  @Getter('getResetFormState') resetFormState!: boolean;
  @paymentDetailsModule.Getter('getResetFormValues') resetFormValues!: {
    mobileMoneyNumber: string;
  };

  @Prop({ default: false, required: true }) state!: boolean;
  @Prop({ default: false }) dialogLoading!: boolean;
  @Prop({ default: false }) loading!: boolean; // button loading
  @Prop({ default: false }) link!: string;

  payment: any = {
    mobileMoneyNumber: '',
    isDefault: false,
  };

  @Watch('resetFormState')
  onFormChange(payload: boolean) {
    if (payload) {
      this.payment = { ...this.resetFormValues };
    } else this.$store.dispatch('resetFormValues', false, { root: true });
  }

  @Emit('payment')
  addPayment() {
    const getCarrier = carriers(this.payment.mobileMoneyNumber);
    if (getCarrier) {
      return {
        loading: {
          idx: 'add',
          state: false,
        },
        body: {
          ...getCarrier,
          isDefault: this.payment.isDefault,
        },
      };
    } else {
      this.$store.dispatch('snackBarVisibility', true, { root: true });
      this.$store.dispatch('snackBarMessage', 'Invalid Phone Number', {
        root: true,
      });
    }
  }

  @Emit('actions')
  close(): PayloadState {
    return {
      idx: 'add',
      state: false,
    };
  }
}
